import React from "react";
import {Text} from "@renta-apps/renta-react-components";
import AlertSubscriptionManagement, {defaultComparer, IBaseAlertSubscriptionManagementProps} from "./AlertSubscriptionManagement";
import Localizer from "@/localization/Localizer";
import styles from "./AlertSubscriptionsManagement.module.scss";
import RangeSlider from "@/components/CustomSlider/RangeSlider";
import AlarmData from "@/models/server/AlarmData";

interface IEnvironmentControlAlertSubscriptionManagementProps extends IBaseAlertSubscriptionManagementProps {
    min?: number | null;
    max?: number | null;
    isAdjustmentEnabled?: boolean;
    onAlertDataChange: (value: AlarmData) => void;
    onAdjustmentChange: (adjusted: boolean) => void;
}

const DEFAULT_MIN_HUMID = 10;
const DEFAULT_MAX_HUMID = 20;

const EnvironmentControlStructureHumidityAlertSubscriptionManagement: React.FC<IEnvironmentControlAlertSubscriptionManagementProps> = ({
    onChange,
    onAlertDataChange,
    onAdjustmentChange,
    min: minTemp,
    max: maxTemp,
    isAdjustmentEnabled,
    ...props
}: IEnvironmentControlAlertSubscriptionManagementProps) => {
    const handleChanged = (checked: boolean) => {
        onChange(checked);
        if (checked && ((minTemp ?? null) === null || (maxTemp ?? null) === null)) {
            onAlertDataChange({value: null, min: DEFAULT_MIN_HUMID, max: DEFAULT_MAX_HUMID});
        }
    };

    return (
        <AlertSubscriptionManagement id="structureHumidity"
                                     label={Localizer.fleetMonitoringPageSubscribeToAlertsModalStructureHumidity}
                                     adjustable
                                     isAdjustmentEnabled={isAdjustmentEnabled}
                                     thresholdText={Localizer.fleetMonitoringPageSubscribeToAlertsModalAdjustHumidityThreshold}
                                     thresholdDescriptionText={Localizer.fleetMonitoringPageSubscribeToAlertsModalAdjustThresholdDescription}
                                     onChange={handleChanged}
                                     onAdjustmentChange={onAdjustmentChange}
                                     {...props}
        >
            {props.checked && (
                <div className={styles.sliderContainer}>
                    <Text tag="label" size="Normal" weight="medium" className={styles.noteRow}>
                        {Localizer.fleetMonitoringPageSubscribeToAlertsModalHumidityHelp}
                    </Text>
                    <RangeSlider min={0} max={50} step={1} values={[minTemp ?? DEFAULT_MIN_HUMID, maxTemp ?? DEFAULT_MAX_HUMID]}
                                 disabled={props.disabled || (!isAdjustmentEnabled && !props.singleDevice)}
                                 onChange={values => {
                                    const [min, max] = values;
                                    onAlertDataChange({value: null, min, max});
                                 }}
                                 unit={"%"} />
                </div>
            )}
        </AlertSubscriptionManagement>
    );
};

const comparer = (prevProps: IEnvironmentControlAlertSubscriptionManagementProps, nextProps: IEnvironmentControlAlertSubscriptionManagementProps) => {
    return defaultComparer(prevProps, nextProps) && (prevProps.min === nextProps.min && prevProps.max == nextProps.max) && prevProps.isAdjustmentEnabled === nextProps.isAdjustmentEnabled;
};

export default React.memo(EnvironmentControlStructureHumidityAlertSubscriptionManagement, comparer);